export default __webpack_public_path__ + "static/media/south-plains-solar-bg.5b5d0f3e.jpeg";